import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useEffect } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { ErrorWord, TemplateProps, yapStringWhen, } from '../common';
import { formErrorScroll } from 'views/mutual/formErrorScroll';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';
import { FatcaStatus } from 'views/utils/enums';

export type FatcaType = {
  fatca : FatcaStatus | null;
};

export const useFatca = ({ isUpdate }: TemplateProps) => {
  const { param, add } = useCorporateAccountEstablishStore();
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  const { messageClose } = useGlobalToastHandler();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const initialValues: FatcaType = {
    fatca: param.fatca,
  };

  const formik = useFormik<FatcaType>({
    enableReinitialize: isUpdate,
    initialValues,
    async onSubmit() {
      add({
        ...param,
        ...formik.values,
      });
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.entryConfirm);
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate: () => {
      // バリデーションかける時に必ずエラートーストを閉じる
      messageClose();
    },
  });

  const fatcaProps = {
    selected: formik.values.fatca,
    onChange: (value: FatcaStatus) => formik.setFieldValue('fatca', value),
    error: formik.errors.fatca,
  };

  useEffect(() => {
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    fatcaProps,
  };
};
